export default {"src":"//_next/static/media/diamond.c37b73ba.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};